document.addEventListener('DOMContentLoaded', () => {
  const mobileMenu = document.querySelector(
    '[data-scope-path="partials/_mobile_menu"]'
  )
  const menuOpener = mobileMenu.querySelector('.js-menu-opener')

  // ボタンを押すたびにメニューを開閉するクラスをトグル制御
  {
    const toggleMenu = mobileMenu.querySelector('.js-toggle-menu')

    menuOpener.addEventListener('click', () => {
      toggleMenu.classList.toggle('js-closed')
      menuOpener.classList.toggle('js-closed')
    })
  }
})
